import {
  DELETE_ASYNC_JOB,
} from '../../types';
import createAsyncActions from '../../../../utilities/createAsyncActions';

export const {
  deleteAsyncJob,
  deleteAsyncJobPending,
  deleteAsyncJobFulfilled,
  deleteAsyncJobRejected,
} = createAsyncActions(DELETE_ASYNC_JOB, 'deleteAsyncJob');



// WEBPACK FOOTER //
// ./src/features/organization/actions/updateActions/deleteAsyncJobAction.js